import { getDateInfo } from './ds-charts.functions';
import { TranslateService } from '@ngx-translate/core';

/**
 * Returns date as YYYY-MM-DD.
 *
 * @param date Given date
 * @returns string
 */
export function getDateString(date: Date): string {
  const dateInfo = getDateInfo(date);
  return `${dateInfo.year}-${dateInfo.month}-${dateInfo.day}`;
}

/**
 * Returns datasets with translated labels.
 *
 * @param datasets List of datasets
 * @param translate Ngx translate
 * @returns Chart.ChartDataSets[]
 */
export function getTranslatedDatasets(
  datasets: Chart.ChartDataSets[],
  translate: TranslateService
): Chart.ChartDataSets[] {
  const formattedDatasets = JSON.parse(JSON.stringify(datasets));
  formattedDatasets.forEach((dataset) => {
    dataset.label = translate.instant(dataset.label);
  });
  return formattedDatasets;
}
